import * as React from 'react'
import { Icon, TooltipHost, Toggle, TooltipDelay } from 'office-ui-fabric-react';

type MyAccountToggleProps = {
    label: string;
    checked: boolean | undefined;
    tooltipContent: JSX.Element;
    onChange: (event: React.MouseEvent<HTMLElement>, checked?: boolean) => void;
    disabled?: boolean;
}

const MyAccountToggle = (props: MyAccountToggleProps) => {
    return <Toggle disabled={props.disabled}
        checked={props.checked}
        onText="Yes"
        offText="No"
        onChange={props.onChange}
        styles={{ label: { flex: 1, fontWeight: "normal" }, root: { marginBottom: "unset" } }}
        inlineLabel={true}
        label={
            <div className='toggle-label'>
                <span>{props.label}</span>
                <TooltipHost styles={{ root: { paddingLeft: 5 } }}
                    delay={TooltipDelay.zero}
                    closeDelay={TooltipDelay.long}
                    tooltipProps={{ onRenderContent: () => props.tooltipContent }}>
                    <Icon iconName="Info" className='info' />
                </TooltipHost>
            </div>
        }
    />
}

export default MyAccountToggle;